
import JavaScriptError from "@/dialogs/JavaScriptError"

export default class

  constructor: ->
    window.onerror = @_onError
    window.addEventListener 'unhandledrejection', @_onUnhandledRejection

  _onError: (message, url, line, column, error) ->
    console.error 'window.onerror:', message, url, line, column, error
    JavaScriptError.make message

  _onUnhandledRejection: (e) ->
    console.error 'unhandledrejection:', e
    JavaScriptError.make e.reason
